import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { Translation } from 'react-i18next'
import i18n from '../../languages/lang.js'
import { REACT_APP_MULTI_LANG_DISABLE } from '../../constants/config'

const HeaderTools = props => {
  const changeLanguage = lng => {
    i18n.changeLanguage(lng)
  }
  if (REACT_APP_MULTI_LANG_DISABLE) {
    return null
  }

  return (
    <Translation>
      {
        (t) => (
          <div id="language"><div id="language-wrap">
            <a className="languageTab" onClick={() => changeLanguage("en")}><img src="/images/en-lang.png" /></a>
            <a className="languageTab" onClick={() => changeLanguage("zh")}><img src="/images/zh-lang.png" /></a>
            <a className="languageTab" onClick={() => changeLanguage("th")}><img src="/images/th-lang.png" /></a>
          </div></div>
        )
      }
    </Translation >
  )
}

export default HeaderTools
